import { Controller } from "stimulus"
import "selectize"

export default class extends Controller {
  static targets = [ "field" ]

  connect() {
    this.fieldTargets.forEach((fieldTarget) => {
      $(fieldTarget).selectize({
        plugins: ['remove_button'],
        allowEmptyOption: true,
        highlight: false,
        preload: 'focus',
        load: this.loadData.bind(this, $(fieldTarget).data("name"))
      })
    })
  }

  loadData(field, value, callback) {
    const business_unit_id = this.data.get("business-unit-id")

    const globalOptions = {
      url: this.data.get("url").concat(".json"),
      type: "GET",
      error: callback
    }

    const optionsForMonitoring = {
      ...globalOptions,
      data: { q: { business_unit_id, field, value } },
      success: (data) => {
        callback(data.map(item => { return { text: item, value: item  } }))
      },
    }

    const optionsForDashboard = (field, value) => {
      switch(field) {
        case "business_unit_id":
          return {
            ...globalOptions,
            data: { q: { dashboard: { field, value } } },
            success: (data) => {
              callback(data.map(item => { return { text: item.name, value: item.id } }))
            },
          }
        case "music_segment_id":
          return {
            ...globalOptions,
            data: { q: { dashboard: { field, value } } },
            success: (data) => {
              callback(data.map(item => { return { text: item[0], value: item[1]}}))
            },
          }
        default:
          return {
            ...globalOptions,
            data: { q: { dashboard: { field, value } } },
            success: (data) => {
              callback(data.map(item => { return { text: item, value: item } }))
            },
          }
      }
    }

    /*
      If a business_unit_id is provided, means that is coming from the monitoring
      screen, so the ajax request will be made with the respective handlers to it.

      Else means that dashboard is requesting the fields for it's filters, which
      can have some specific cases that need special handlers (like business_unit_id,
      that's why it is a function instead of a object)
    */
    if (business_unit_id) $.ajax(optionsForMonitoring)
    else $.ajax(optionsForDashboard(field, value))
  }
}

